/**
 * Einzige Quelle für die Optik des aktiven Reiters / der aktiven Umschalt-Wahl (Rudolf 13.10.2026 Popup, Ticket 1.154;
 * Redesign 31.10.2026 Variante C): Reiter = dunkle Pille (Schriftfarbe) ohne Spur; Umschalter (`seg`) = helle, leicht
 * erhabene Pille auf grauer Spur (`seg-on`). Dunkelblau bleibt Hauptknopf und Markierungen vorbehalten. Segment, Ansichten-Reiter, Bereiche-Reiter des Datensatzes,
 * Kunden-Bereiche und Einstellungs-Reiter rufen nur `tabStateClass`. Wer die Farbe ändern will, ändert sie hier;
 * `test/tab-style.test.ts` meldet Kopien der alten weißen Pille.
 */
export const TAB_ACTIVE = 'bg-ink text-on-ink';
export const TAB_INACTIVE = 'text-ink-2 hover:bg-hover hover:text-ink';
/** Umschalter (Segment, Kennzahl-/Zeitraum-Wahl der Diagramme): helle, erhabene Pille auf grauer Spur (`TAB_TRACK`). */
export const SEG_ACTIVE = 'bg-seg-on text-ink shadow-seg-on';
export const SEG_INACTIVE = 'text-ink-2 hover:text-ink';
/** Zähler hinter dem Reiternamen (auf der dunklen Pille leicht gedämpft). */
export const TAB_COUNT_ACTIVE = 'text-on-ink opacity-[var(--opacity-soft)]';
export const TAB_COUNT_INACTIVE = 'text-ink-3';
export const SEG_COUNT_ACTIVE = 'text-ink-2';

/**
 * Eigene Ansichten (Story 1.82, Entwurf A wie Muster `auftraege-s3.html`): stehen nach dem Strich außerhalb der grauen
 * Kapsel als gestrichelte Pille (Rand `chip-line`); aktiv wie jeder Reiter dunkelblau gefüllt, der Rand wird unsichtbar
 * (gleiche Größe, kein Springen). Auch der Knopf „+ Ansicht“ nutzt die gestrichelte Fassung.
 */
export const TAB_OWN_INACTIVE = 'border border-dashed border-chip-line text-ink-2 hover:text-ink';
export const TAB_OWN_ACTIVE = `border border-transparent ${TAB_ACTIVE}`;

/**
 * Ansichten-Reiter der Listen (Redesign N40, Sichtung HS55 01.11.2026): leiser als die dunkle Pille. Freigegebene Ansichten
 * stehen auf der grauen Spur (`SEG_TRACK`) mit heller, erhabener Pille (`SEG_ACTIVE`); eine aktive eigene Ansicht ist eine
 * graue Pille ohne Strichrand (gleiche Größe wie gestrichelt, kein Springen).
 */
export const VIEW_OWN_ACTIVE = 'border border-transparent bg-fill text-ink';

export function tabStateClass(active: boolean, opts: { own?: boolean; seg?: boolean } = {}): string {
  if (opts.own) return active ? TAB_OWN_ACTIVE : TAB_OWN_INACTIVE;
  if (opts.seg) return active ? SEG_ACTIVE : SEG_INACTIVE;
  return active ? TAB_ACTIVE : TAB_INACTIVE;
}

/** Reiterzeile ohne Spur (Redesign 31.10.2026, Variante C): Reiter als Text, der aktive als dunkle Pille. */
// `pr-px`: 1 px Luft hinter der letzten Pille – sonst bleibt bis ans Ende gescrollt ein Bruchteil eines Pixels abgeschnitten
// (Scroll-Wert ganzzahlig, Pillenbreite nicht).
export const TAB_TRACK = 'inline-flex items-center gap-space-1 pr-px';

/** Spur hinter den Umschaltern (graue Pille, in der die Reiter stehen; Innenabstand und Lücke 4 px); Datensatz-Reiterleiste und Sprung-Reiter. */
export const SEG_TRACK = 'inline-flex items-center gap-track-gap rounded-full bg-fill p-track-pad';
